<template>
    <div>
        <h1 class="display-heading">Patient Details</h1>

        <div>
            <table class="table table-bordered table-sm">
                <colgroup>
                    <col width="250">
                    <col>
                </colgroup>
                <tr>
                    <th colspan="2" class="text-uppercase">General Info</th>
                </tr>
                <tr>
                    <th>Join Date</th>
                    <td>{{userProfile.joinedDate}}</td>
                </tr>
                <tr>
                    <th>Full Name</th>
                    <td>{{userProfile.designation ? `${userProfile.designation} ${userProfile.name}` : userProfile.name }}</td>
                </tr>
                <tr>
                    <th>Identification Type</th>
                    <td>{{userProfile.identitifcationType}}</td>
                </tr>
                <tr>
                    <th>Identification Number</th>
                    <td>{{userProfile.identificationNumber}}</td>
                </tr>
                <tr>
                    <th>Birth Date</th>
                    <td>{{userProfile.birthDate}}</td>
                </tr>
                <tr>
                    <th>Gender</th>
                    <td>{{userProfile.gender}}</td>
                </tr>
                <tr>
                    <th>Email Address</th>
                    <td>{{userProfile.email}}</td>
                </tr>
                <tr>
                    <th>Phone Number</th>
                    <td>{{userProfile.phoneNo}}</td>
                </tr>
            </table>

            <table class="table table-bordered table-sm">
                <colgroup>
                    <col width="250">
                    <col>
                </colgroup>
                <tr>
                    <th colspan="2" class="text-uppercase">Address Details</th>
                </tr>
                <tr>
                    <th>Address Line 1</th>
                    <td>{{ address.line1 ? address.line1 : '-' }}</td>
                </tr>
                <tr>
                    <th>Address Line 2</th>
                    <td>{{ address.line2 ? address.line2 : '-' }}</td>
                </tr>
                <tr>
                    <th>Postcode</th>
                    <td>{{ address.postcode ? address.postcode : '-' }}</td>
                </tr>
                <tr>
                    <th>City</th>
                    <td>{{ address.city ? address.city : '-' }}</td>
                </tr>
                <tr>
                    <th>State</th>
                    <td>{{ address.state ? address.state : '-' }}</td>
                </tr>
            </table>

            <table class="table table-bordered table-sm">
                <colgroup>
                    <col width="250">
                    <col>
                </colgroup>
                <tr>
                    <th colspan="2" class="text-uppercase">Mailing Address Details</th>
                </tr>
                <tr>
                    <th>Address Line 1</th>
                    <td>{{ mailingAddress.line1 ? mailingAddress.line1 : '-' }}</td>
                </tr>
                <tr>
                    <th>Address Line 2</th>
                    <td>{{ mailingAddress.line2 ? mailingAddress.line2 : '-' }}</td>
                </tr>
                <tr>
                    <th>Postcode</th>
                    <td>{{ mailingAddress.postcode ? mailingAddress.postcode : '-' }}</td>
                </tr>
                <tr>
                    <th>City</th>
                    <td>{{ mailingAddress.city ? mailingAddress.city : '-' }}</td>
                </tr>
                <tr>
                    <th>State</th>
                    <td>{{ mailingAddress.state ? mailingAddress.state : '-' }}</td>
                </tr>
            </table>

            <button class="btn btn-primary btn-primary-insv" @click="backToList">Back to List</button>
        </div>
    </div>
</template>

<script>
import identificationTypes from '@/config/identificationTypes';
import {
    convertDateToDDMMYYYY
} from '@/utilities';
export default {
    'name': 'DoctorApprovalDetails',
    'computed': {
        patientId () {
            return this.$route.params.id;
        }
    },
    data () {
        return {
            'userProfile': {
                'designation': null,
                'name': null,
                'email': null,
                'phoneNo': null,
                'identitifcationType': null,
                'identificationNumber': null,
                'joinedDate': null,
                'birthDate': null,
                'gender': null
            },
            'address': {
                'line1': null,
                'line2': null,
                'postcode': null,
                'city': null,
                'state': null
            },
            'mailingAddress': {
                'line1': null,
                'line2': null,
                'postcode': null,
                'city': null,
                'state': null
            }
        };
    },
    mounted () {
        this.getPatientDetails();
    },
    'methods': {
        getPatientDetails () {
            this.axios.get('user/GetUserDetails', {
                'params': {
                    'userId': this.patientId
                }
            }).then(({
                data
            }) => {
                if (data.data) {
                    let profileData = data.data;
                    this.userProfile.designation = profileData.d;
                    this.userProfile.name = profileData.f;
                    this.userProfile.email = profileData.e;

                    let idType = identificationTypes.find(i => i.value === profileData.ict);

                    this.userProfile.identitifcationType = idType ? idType.text : '-';
                    this.userProfile.identificationNumber = profileData.ic;
                    this.userProfile.phoneNo = profileData.p;
                    this.userProfile.joinedDate = convertDateToDDMMYYYY(data.data.jd);
                    this.userProfile.birthDate = profileData.bd === null ? 'Not Specified' : convertDateToDDMMYYYY(profileData.bd);
                    this.userProfile.gender = profileData.g === 0 ? 'Not Specified' : profileData.g === 1 ? 'Male' : 'Female';

                    let addressDetails = data.data.up;

                    if (addressDetails) {
                        this.address.line1 = addressDetails.al1;
                        this.address.line2 = addressDetails.al2;
                        this.address.postcode = addressDetails.ap;
                        this.address.city = addressDetails.ac;
                        this.address.state = addressDetails.as;

                        this.mailingAddress.line1 = addressDetails.mal1;
                        this.mailingAddress.line2 = addressDetails.mal2;
                        this.mailingAddress.postcode = addressDetails.map;
                        this.mailingAddress.city = addressDetails.mac;
                        this.mailingAddress.state = addressDetails.mas;
                    }
                }
            });
        },
        backToList () {
            window.history.back();
        }
    }
};
</script>
